export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 p-8 md:p-10 rounded-2xl bg-gradient-to-br from-primary-50 via-background-50 to-accent-50 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-smartphone-line"></i>
              移动端入口
            </span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
              随时随地，吃瓜不间断
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 max-w-[480px] mx-auto lg:mx-0">
              关注我们的社交媒体账号或添加收藏，无论在地铁、午休还是睡前，打开手机就能看到今天吃瓜与今日八卦的最新推送，每日吃瓜实时更新不再错过。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-medium rounded-full transition-colors whitespace-nowrap text-sm"
              >
                <i className="ri-wechat-line"></i>
                关注公众号
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 hover:bg-background-100 text-foreground-700 font-medium rounded-full border border-background-300 transition-colors whitespace-nowrap text-sm"
              >
                <i className="ri-bookmark-line"></i>
                加入收藏
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-background-50 border border-background-200/70 flex items-center justify-center">
              <i className="ri-smartphone-line text-6xl text-primary-400"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}